<div class="card" id="pozeAnimal" [formGroup]="animalForm">
  <div class="card-header">Poze Animal</div>

  <div class="card-body d-flex align-items-center flex-wrap column-gap-4 flex-column flex-md-row">
    <div
      *ngFor="let item of formData.controls; let i = index; let last = last; let first = first"
      class="image-width d-flex flex-column mb-3"
    >
      <img
        *ngIf="imageUrls[i]"
        src="{{ imageUrls[i] }}"
        class="mb-2"
      >

      <div class="d-flex flex-wrap mb-2">
        <span
          class="file-button"
          (click)="downloadImage(i)"
        >
          {{ formData.controls[i].value.uploaded_file_name }}
        </span>

        <button
          *ngIf="!disabledFields['poze']"
          type="button"
          class="btn btn-lg p-0 ml-1 mdi mdi-delete text-danger"
          ngbTooltip="Șterge fișier"
          (click)="deleteImage(i)"
        >
        </button>

        <button
          *ngIf="formData.controls[i].value.filetype === 'default'"
          type="button"
          class="btn btn-sm btn-secondary ml-auto disabled"
        >
          Poza implicita
        </button>

        <button
          *ngIf="!disabledFields['poze'] && formData.controls[i].value.filetype !== 'default'"
          type="button"
          class="btn btn-sm btn-info ml-auto"
          (click)="setDefaultPicture(i)"
        >
          Seteaza implicit
        </button>
      </div>

    </div>

    <div
      *ngIf="!disabledFields['poze']"
      class="w-100 mb-2"
    >
      <app-upload-fisier
        [multiple]="true"
        (ApiResponse)="uploadServerResponse($event)"
      >
      </app-upload-fisier>
    </div>
  </div>
</div>
